<template>
  <bita-modal
    id="log-form"
    title="گزارش فعالیت راننده"
    :modal-lg="true"
    :isLoading="isLoadingModal"
    @close="onCloseModal"
  >
    <div slot="body">
      <div class="text-left">
        <bita-bootbutton
          type="warning mb-3"
          title="رفع محدودیت رزرو راننده"
          btn-width="200px"
          @click.native="reemoveAccess"
        />
      </div>
      <div class="row">
        <bita-datepicker
          type="date"
          id="fromDate"
          validation-container-class="col-lg-4"
          name="from-date"
          label="از تاریخ"
          inputClass="form-control"
          @change="loadData"
          v-model="filters.fromDate"
        />
        <bita-datepicker
          type="date"
          id="toDate"
          validation-container-class="col-lg-4"
          name="from-date"
          label="تا تاریخ"
          inputClass="form-control"
          @change="loadData"
          v-model="filters.toDate"
        />
        <bita-select
          name="status"
          label="نوع لاگ"
          ref="statusDropDown"
          validation-container-class="col-lg-4"
          input-class="form-control"
          :data-source="statuses"
          data-text-field="name"
          data-value-field="id"
          v-model="filters.type"
          @change="loadData"
        />
      </div>
      <bita-grid
        v-if="showGrid"
        ref="logGrid"
        :columns="gridColumns"
        :read-data="readData"
        :hasRow="false"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  data() {
    return {
      isLoadingModal: false,
      showGrid: false,
      driver: {},
      filters: {},
      statuses: [
        { id: 1, name: "کنسلی" },
        { id: 2, name: "رزرو" },
      ],
    };
  },
  computed: {
    gridColumns() {
      return [
        {
          title: "مبدا",
          template: (e) =>
            e.request && e.request.origin_name ? e.request.origin_name : "-",
        },
        {
          title: "مقصد",
          template: (e) =>
            e.request && e.request.destination_name
              ? e.request.destination_name
              : "-",
        },
        {
          title: "تاریخ بارگیری",
          template: (e) =>
            e.request && e.request.loading_at
              ? this.$getJalaliDate(e.request.loading_at)
              : "-",
        },
        { title: "وضعیت", template: (e) => (e.state ? e.state : "-") },
      ];
    },
  },
  methods: {
    setInitialData(_driver) {
      this.showGrid = true;
      this.driver = _driver;
    },
    readData(e) {
      this.isLoadingModal = true;
      let baseUrl = `drivers/${this.driver.id}/request-tickets`,
        url = this.$makeQueryString(baseUrl, this.filters);
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => e.success([]))
        .finally(() => (this.isLoadingModal = false));
    },
    loadData() {
      this.$refs.logGrid.loadDataSource();
    },
    onCloseModal() {
      this.filters = {};
      this.showGrid = false;
      this.$refs.statusDropDown.emptyKendo();
    },
    reemoveAccess() {
      this.$alert(
        "question",
        `آیا از رفع محدودیت رزرو این کاربر اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingModal = true;
          this.$persistClient("delete", `drivers/${this.driver.id}/logs`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
            })
            .finally(() => {
              this.isLoadingModal = false;
            });
        }
      });
    },
  },
};
</script>
